import React from 'react'
import { assetPrefix } from 'src/config/env_config'
import * as S from './styles'

const icons = {
  info: `${assetPrefix}/static/icons/info-icon.svg`,
  danger: `${assetPrefix}/static/icons/danger-icon.svg`,
  warning: `${assetPrefix}/static/icons/warning-icon.svg`
}

const Alert = ({ type = 'info', show, children, textContent, margin, textTitle, onClose }) => {
  return (
    <>
      {show && (
        <S.AlertContainer margin={margin} type={type}>
          <S.Icon src={icons[type]} />
          {(textTitle || textContent) &&
            <div>
              {textTitle && <S.Title>{textTitle}</S.Title>}
              {textContent && <p>{textContent}</p>}
            </div>}
          <S.Message>{children}</S.Message>
          {onClose && (
            <S.CloseButton type='button' onClick={onClose} aria-label='Fechar alerta' data-test='alert-close'>
              <S.CloseIcon src={`${assetPrefix}/static/icons/times.svg`} alt='' />
            </S.CloseButton>
          )}
        </S.AlertContainer>
      )}
    </>
  )
}

export default Alert
